import React from 'react'

import {
  AlignItems,
  Box,
  Col,
  Color,
  Display,
  FlexDirection,
  FontWeight,
  Grid,
  JustifyContent,
  Space,
  Text,
  TextAlign,
} from '@gousto-internal/citrus-react'

export const DiscountPerWeek = () => {
  const discountBoxes = [
    { discount: '50% OFF', label: '1st box', bgColor: Color.Primary_400, textColor: Color.White },
    { discount: '40% OFF', label: '2nd box', bgColor: Color.ColdGrey_500, textColor: Color.White },
    {
      discount: '20% OFF',
      label: '3rd-7th box',
      bgColor: Color.ColdGrey_500,
      textColor: Color.White,
    },
    { discount: 'FREE', label: '8th box', bgColor: Color.White, textColor: Color.ColdGrey_800 },
  ]

  return (
    <Box display={Display.Flex} data-testid="discount-per-week">
      <Grid columnGap={[5, 4]}>
        {discountBoxes.map((box) => (
          <Col key={box.label} size={3}>
            <Box
              display={Display.Flex}
              alignItems={AlignItems.Center}
              flexDirection={FlexDirection.Column}
            >
              <Box
                bg={box.bgColor}
                borderRadius={1.5}
                width="64px"
                height="64px"
                display={Display.Flex}
                alignItems={AlignItems.Center}
                justifyContent={JustifyContent.Center}
              >
                <Text
                  size={4}
                  color={box.textColor}
                  fontWeight={FontWeight.Bold}
                  textAlign={TextAlign.Center}
                >
                  {box.discount}
                </Text>
              </Box>

              <Space size={2} />

              <Text
                size={0}
                color={Color.White}
                textAlign={TextAlign.Center}
                style={{ whiteSpace: 'nowrap' }}
              >
                {box.label}
              </Text>
            </Box>
          </Col>
        ))}
      </Grid>
    </Box>
  )
}
